/**
 * @generated SignedSource<<edda4e3dd30ca8cf6adeddd3dbc8df0b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTypeCell$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IconCell">;
  readonly " $fragmentType": "IssueTypeCell";
};
export type IssueTypeCell$key = {
  readonly " $data"?: IssueTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTypeCell",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IconCell"
    }
  ],
  "type": "JiraIssueTypeField"
};

(node as any).hash = "877c101cf6c61ca9ea0f6a9dfeefabab";

export default node;
